<template>
    <div class="form-box">
        <div class="form-left">
            <p v-for="(item,index) in dataTree" :key="index" :class="(curId==index?'on':'')" @click="handleNodeClick(item,index)" style="width:100%;height:4vh;position: relative;display: flex;align-content: center;align-items: center;padding-left: 1vh;cursor: pointer;">
                {{item.name}}
            </p>
        </div>
        <div class="form-right from7-r">
            <div style="width:100%;height:5vh;padding-left:1vw;background:#fff;display:flex;align-items: center;">
                <el-page-header @back="goBack" content="项目关键节点计划"></el-page-header>
            </div>
            <div style="width:100%;height:calc( 100% - 5vh );position: relative;padding:1vh;background:#fff;">
                <el-table :data="tableData" border style="width: 100%" height="100%" :header-row-class-name="'table-head'">
                    <template slot="empty">
                        <p>{{dataText}}</p>
                    </template>
                    <el-table-column prop="index" label="序号" width="200">
                        <template slot-scope="scope">
                            <span>{{scope.row.index}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="nodeTypeName" label="关键节点">
                        <template slot-scope="scope">
                            <span>{{scope.row.nodeTypeName}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="startTime" label="计划开始时间">
                        <template slot-scope="scope">
                            <span>{{scope.row.startTime}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="actualStartTime" label="实际开始时间">
                        <template slot-scope="scope">
                            <span>{{scope.row.actualStartTime}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="completeTime" label="计划完成时间">
                        <template slot-scope="scope">
                            <span>{{scope.row.completeTime}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="actualCompleteTime" label="实际完成时间">
                        <template slot-scope="scope">
                            <span>{{scope.row.actualCompleteTime}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="actualCompleteTime" label="实际完成情况">
                        <template slot-scope="scope">
                            <span  v-if="scope.row.intervalDay>0" style="color:#f00">滞后{{scope.row.intervalDay}}天</span>
                            <span  v-if="scope.row.intervalDay<0" style="color:#409eff">提前{{scope.row.intervalDay}}天</span>
                            <span  v-if="scope.row.intervalDay==0">按时完成</span>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-button type="success" @click="infoFun(scope.row)">查看</el-button>
                        </template>
                    </el-table-column> -->
                </el-table>

            </div>
        </div>
    </div>
</template>

<script>
import myHttp from '../../../untils/port'
import util from '../../../untils/util'
export default {
    data(){
        return{
            groupId:'',
            dataTree:[],
            defaultProps: {
                children: 'list',
                label: 'name'
            },
            projectId:'',//当前项目id
            currentNodekey:'',//当前树形选中值
            expandedkeys:[],//树形展开值
            dataText: '数据加载中...',
            tableData:[],
            curId:0,
        }
    },
    mounted(){
        this.groupId = util.session.get('groupId')
        this.getLeftMenu()
        // this.getData()
        // let list =[{num:'2',name:'zhangsan',count:'1',},{num:'2',name:'zhangsan',count:'1'}]
        // let arr=[]
        // list.forEach((item,index)=>{
        //    delete item.num
        // })
        //  arr= list
        // console.log(arr)
   
    },
    methods:{
        //获取侧边树
        getLeftMenu(){
            var that = this
            myHttp.getEntProjectList({
                groupId: this.groupId,
                pageNum:1,
                pageSize:10000
            }).then(function(resp) {
                if (resp.data.code == '200') {
                    var list = resp.data.data.entProject.list || []
                    that.dataTree = list
                    if (list.length > 0 && that.projectId=='') {
                        that.projectId= list[0].projectId
                        that.getData()
                    }
                }
            })
        },
        //树形点击
        handleNodeClick(e,index){
            this.projectId = e.projectId
            this.curId = index
            this.getData()
        },
        //获取数据
        getData(){
            if(!this.projectId||this.projectId==''){
                this.tableData = []
                this.dataText = '暂无数据'
                return
            }
            var that = this
            this.tableData = []
            myHttp.projectNodeList({
                projectId:this.projectId
            }).then(function(resp){
                console.log(resp)
                if(resp.data.code=='200'){
                    var list = resp.data.data
                    for(var i=0;i<list.length;i++){
                        list[i].index = i+1
                        list[i].actualCompleteTime = list[i].actualCompleteTime && list[i].actualCompleteTime!=''?list[i].actualCompleteTime.split(' ')[0]:''
                    }
                    that.tableData = list
                    if(list.length==0){
                        that.dataText = '暂无数据'
                    }
                }else{
                    that.dataText = '暂无数据'
                }
            })
        },

        //返回
        goBack(){
            this.$router.go(-1)
        },
    }
}
</script>

<style scoped>
    .form-box{
        width: 100%;
        height: 100%;
        position: relative;
        display: flex;
        padding: 1vh;
    }
    .form-left{
        width:15vw;
        height: 100%;
        position: relative;
        background: #fff;
        padding: 1vh;
        display: flex;
        flex-wrap: wrap;
        align-content: flex-start;
        align-items: flex-start;
    }
    .form-left .on{
        color: #2447D7;
    }
    .form-right{
        width: calc( 100% - 15vw );
        height: 100%;
        position: relative;
        padding-left: 1vh;
    }
</style>

<style>
    @import '../../../assets/css/common.css';
    .el-table--border th, .el-table__fixed-right-patch{
        border-bottom: 1px solid #303133;
    }
    .el-table--border td, .el-table--border th, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed{
        border-right: 1px solid #303133;
    }
    .el-table td, .el-table th.is-leaf{
        border-bottom: 1px solid #303133;
    }
    .el-table--border, .el-table--group{
        border: 1px solid #303133;
    }
    .from7-r .el-table--border th:nth-child(3),.from7-r .el-table--border td:nth-child(3){
        border-right: 1px solid #dddddd;
    }
    .from7-r .el-table--border th:nth-child(5),.from7-r .el-table--border td:nth-child(5){
        border-right: 1px solid #dddddd;
    }
</style>